import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Swal from 'sweetalert2';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { toast } from 'react-toastify';
import CallToActionSecondModal from './CallToActionSecondModal';


const CallToActionSection2 = () => {
    const url = API_BASE_URL;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const { globalSearch } = useSearch();
    const [data, setData] = useState({
        title: "",
        button_text: "",
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
        position: "",
        iconLabelPairs: [],
        options: [],
        status: "",
    })
    const [slider, setSlider] = useState([])
    const [load, setLoad] = useState(false);
    const token = decryptToken("accessToken") || ""

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    // const [ageGroups, setAgeGroups] = useState([
    //     // Sample data (replace with actual data)
    //     { minAge: 18, maxAge: 25, status: 'Active' },
    //     { minAge: 26, maxAge: 35, status: 'Deactive' },
    //     { minAge: 36, maxAge: 50, status: 'Active' },
    // ]);
    const [filteredAgeGroups, setFilteredAgeGroups] = useState(slider);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = slider.filter((group) =>
            Object.values(group).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredAgeGroups(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, slider]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAgeGroups.length / itemsPerPage);
    const currentData = filteredAgeGroups.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setSlider((prevGroups) =>
            prevGroups.map((group, i) =>
                i === index
                    ? { ...group, status: group.status === 'Active' ? 'Deactive' : 'Active' }
                    : group
            )
        );
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "This will permanently delete the slider!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${url}/calltoactionsecond/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });

                const res = await response.json();

                if (response.ok) {
                    Swal.fire('Deleted!', 'Call to Action has been deleted.', 'success');
                    sliderFetch(); // Refresh the slider list
                } else {
                    Swal.fire('Error!', res.message || 'Failed to delete.', 'error');
                }
            } catch (error) {
                Swal.fire('Error!', 'Something went wrong.', 'error');
                console.error(error);
            }
        }
    };
    const sliderFetch = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/calltoactionsecond/all/${isLoggedIn.main_id}`);
            const res = await response.json();

            // const parsed = res.map(item => {
            //     const safeParse = (val, fallback = []) => {
            //         try {
            //             return typeof val === 'string' ? JSON.parse(val) : val || fallback;
            //         } catch {
            //             return fallback;
            //         }
            //     };

            //     return {
            //         ...item,
            //         product_id: safeParse(item.product_id),
            //         product: safeParse(item.product).map(p => ({
            //             ...p,
            //             gallery: safeParse(p.gallery),
            //             key_features: safeParse(p.key_features),
            //             specifications: safeParse(p.specifications),
            //             variation: safeParse(p.variation),
            //             attribute: safeParse(p.attribute),
            //             downloadable_files: safeParse(p.downloadable_files),
            //         }))
            //     };
            // });

            // const sortedCategories = Array.isArray(parsed)
            //     ? parsed.sort((a, b) => a.position - b.position)
            //     : [];

            setSlider(res);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false)
        }
    };

    useEffect(() => {
        sliderFetch();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }


    return (
        <>
            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Call To Action Section Second</h1>

                    {/* Add Fees Button */}
                    {/* {
                        slider.length === 0 && <button
                            className="oms-add-btn"
                            onClick={() => {
                                // Reset the form to default empty values
                                setData({
                                    title: "",
                                    button_text: "",
                                    user_id: isLoggedIn.main_id,
                                    user_name: isLoggedIn.full_name,
                                    position: "",
                                    iconLabelPairs: [],
                                    options: [],
                                    status: "",
                                });
                                setIsModalOpen(true);
                            }}
                        >
                            Add
                        </button>
                    } */}

                </div>

                {/* Search Filter */}
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div> */}

                {/* Age Groups Table */}

                <div className="customer-table responsive-table">
                    {/* <DragDropContext
                        onDragEnd={async (result) => {
                            const { destination, source } = result;
                            if (!destination || destination.index === source.index) return;

                            const reordered = Array.from(slider);
                            const [movedItem] = reordered.splice(source.index, 1);
                            reordered.splice(destination.index, 0, movedItem);

                            const updatedOrder = reordered.map((cat, index) => ({
                                id: cat.id,
                                position: index + 1,
                            }));

                            setSlider(reordered);

                            try {
                                const res = await fetch(`${url}/newarrival/update-order/drag`, {
                                    method: "PUT",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({ updatedOrder }),
                                });
                                const data = await res.json();
                                if (res.ok) {
                                    toast.success(data.message);
                                    sliderFetch();
                                }
                                else toast.error(data.message);
                            } catch (err) {
                                console.error(err);
                                toast.error("Failed to update order");
                            }
                        }}
                    > */}
                    {/* <Droppable droppableId="categories">
                            {(provided) => ( */}
                    <table

                    // {...provided.droppableProps} 
                    // ref={provided.innerRef}
                    >
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Button Text</th> {/* New column */}
                                {/* <th>Position</th> */}
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((group, index) => (
                                    // <Draggable key={group.id.toString()} draggableId={group.id.toString()} index={index}>
                                    //     {(provided, snapshot) => (
                                    <tr key={index}
                                    // ref={provided.innerRef}
                                    // {...provided.draggableProps}
                                    // {...provided.dragHandleProps}
                                    // className={snapshot.isDragging ? "dragging-row" : ""}
                                    // style={{
                                    //     ...provided.draggableProps.style,
                                    //     background: snapshot.isDragging ? "#f0f8ff" : "white",
                                    // }}
                                    >
                                        <td>{group.title || "N/A"}</td>
                                        <td>
                                            {group.button_text}
                                        </td>
                                        {/* <td>{group.position}</td> */}
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setData({
                                                        id: group.id,
                                                        title: group.title,
                                                        button_text: group.button_text,
                                                        position: group.position,
                                                        status: group.status,
                                                        user_id: group.main_id,
                                                        user_name: group.full_name,
                                                        iconLabelPairs: group.iconLabelPairs,
                                                        options: group.options
                                                    }); // 👈 preload the selected group's data including `_id`
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(group.id)} // or group._id
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>

                                        </td>
                                    </tr>
                                    //     )}
                                    // </Draggable>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center' }}>
                                        No Sections Added.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                    {/* )}
                        </Droppable>
                    </DragDropContext> */}
                </div>

                <DragDropContext
                    onDragEnd={async (result) => {
                        const { destination, source } = result;
                        if (!destination || destination.index === source.index) return;

                        const reordered = Array.from(slider);
                        const [movedItem] = reordered.splice(source.index, 1);
                        reordered.splice(destination.index, 0, movedItem);

                        const updatedOrder = reordered.map((cat, index) => ({
                            id: cat.id,
                            position: index + 1,
                        }));

                        setSlider(reordered);

                        try {
                            const res = await fetch(`${url}/newarrival/update-order/drag`, {
                                method: "PUT",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ updatedOrder }),
                            });
                            const data = await res.json();
                            if (res.ok) {
                                toast.success(data.message);
                                sliderFetch();
                            } else toast.error(data.message);
                        } catch (err) {
                            console.error(err);
                            toast.error("Failed to update order");
                        }
                    }}
                >
                    <Droppable droppableId="mobileCategories">
                        {(provided) => (
                            <div className="ecom-responsive-cards"  {...provided.droppableProps}
                                ref={provided.innerRef}>
                                {currentData.length === 0 ? (
                                    <p style={{ textAlign: "center", margin: "50px" }}>No Sections Added</p>
                                ) : (
                                    currentData.map((group, index) => (
                                        <Draggable
                                            key={group.id.toString()}
                                            draggableId={group.id.toString()}
                                            index={index}
                                        >
                                            {(provided, snapshot) => (
                                                <div className={`ecom-responsive-card ${snapshot.isDragging ? "dragging-row" : ""}`}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={{
                                                        ...provided.draggableProps.style,
                                                        ...(snapshot.isDragging ? {
                                                            background: "var(--primary-soft)",
                                                            boxShadow: "0px 4px 8px rgba(0,0,0,0.35)",
                                                        } : {}),
                                                        borderRadius: "10px",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                    key={index}>

                                                    <div className="ecom-responsive-header">
                                                        <p onClick={() => {
                                                            let parsedProduct = group.product;

                                                            try {
                                                                // Handle double-stringified product
                                                                if (typeof parsedProduct === "string") {
                                                                    parsedProduct = JSON.parse(parsedProduct);
                                                                    if (typeof parsedProduct === "string") {
                                                                        parsedProduct = JSON.parse(parsedProduct);
                                                                    }
                                                                }
                                                            } catch (e) {
                                                                console.warn("Error parsing product:", e);
                                                                parsedProduct = {}; // fallback
                                                            }

                                                            setData({
                                                                ...group,
                                                                product: parsedProduct,
                                                            });

                                                            setIsModalOpen(true);
                                                        }}><Pencil size={20} /> <span>Edit</span></p>
                                                        <p><Trash2 size={20} onClick={() => handleDelete(group.id)} /> <span>Delete</span></p>
                                                    </div>

                                                    <div className="ecom-responsive-body">
                                                        <div className="ecom-responsive-left">
                                                            <h2>{group.category_name || "Not Provided"}</h2>
                                                            <p><ProductListDisplay products={group.products} /></p>
                                                            {/* <div className="ecom-card-images">
                                            <div>
                                                <p>Main Image</p>
                                                <img src={group.image} alt="" style={{ width: "50px", height: "50px" }} />
                                            </div>
                                            <div>
                                                <p>Background Image</p>
                                                <img src={group.background_image} style={{ width: "50px", height: "50px" }} alt="" />
                                            </div>
                                        </div> */}
                                                        </div>

                                                        {/* <div className="ecom-responsive-right">
                                        <h4>₹{group.price}</h4>
                                        <p>₹{group.cutOffPrice}</p>
                                    </div> */}
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))

                                )}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}
            </div>

            {
                slider.length === 0 &&
                <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                    <button
                        onClick={() => {
                            // Reset the form to default empty values
                            setData({
                                title: "",
                                button_text: "",
                                user_id: isLoggedIn.main_id,
                                user_name: isLoggedIn.full_name,
                                position: "",
                                iconLabelPairs: [],
                                options: [],
                                status: "",
                            });
                            setIsModalOpen(true);
                        }}
                        className="cssbuttons-io-button">
                        <span>Add</span>
                    </button>
                </div>
            }

            <CallToActionSecondModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={data} setData={setData} sliderFetch={sliderFetch} />
        </>
    );
};



const ProductListDisplay = ({ products = [] }) => {
    const [showAll, setShowAll] = useState(false);
    if (!products.length) return <span>No products</span>;

    const visibleProducts = showAll ? products : products.slice(0, 3);
    const titles = visibleProducts.map(p => p.title).join(", ");

    return (
        <div>
            <span>{titles}</span>
            {products.length > 3 && (
                <button className="toggle-btn" onClick={() => setShowAll(!showAll)}>
                    {showAll ? "Show Less" : "Show More"}
                </button>
            )}
        </div>
    );
};



export default CallToActionSection2;
